import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

import { settingsModel } from '../../services';

export type CmsSettingState = {
  setting: Partial<settingsModel>;
};
const initState: CmsSettingState = {
  setting: {
    OTPCountDown: 0,
    experienceDescription: '',
    foodMenuUrl: '',
    voucherRedemptionDescription: '',
    contactUsDescription: '',
    offerDescription: '',
    foodMenuDescription: '',
    tempLoginVistaIssue: '',
    minAmountTopUp: 0,
    maxAmountTopUp: 0,
  },
};

export const useCmsSetting = createStore({
  name: 'setting',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setCmsSetting: handler('setting'),
  };
});
